export const primary = '#2196F3';
export const secondary = '#F50057';

export const white = '#FFFFFF';
export const whiteTransparent = 'rgba(255, 255, 255, 0.4);';

export const black = '#000000DE';

export const gray = '#E0E0E0';
export const darkGray = '#646464';
export const mediumGray = '#979797';
export const lightGray = '#CACACA';

export const bgDarkGray = '#F2F2F2';
export const bgLightGray = '#F6F6F6';

export const orange = '#FFA200';
export const darkOrange = '#FE622D';
export const flatOrange = '#FC4236';
export const red = '#FF2400';
export const purple = '#B71B46';
export const green = '#2ECC71';

export const darkBlue = '#28384A';

export const yellow = '#ffff03';
export const yellowTransparent = 'rgba(255, 255, 3, 0.4)';
export const skyBlue = '#2680EB';

export const messageSend = '#E1FFC9';
export const messageReceived = '#F0F0F0';

export const COLORS_UI = ['#F44336', '#9C27B0', '#3F51B5', '#03A9F4', '#009688', '#8BC34A', '#E65100', '#795548', '#E91E63', '#673AB7', '#1E88E5', '#006064', '#43A047', '#827717', '#F4511E'];

export default {
  skyBlue,
  primary,
  secondary,
  white,
  whiteTransparent,
  black,
  gray,
  darkGray,
  mediumGray,
  lightGray,
  bgDarkGray,
  bgLightGray,
  orange,
  darkOrange,
  flatOrange,
  red,
  purple,
  green,
  darkBlue,
  yellow,
  yellowTransparent,
  messageSend,
  messageReceived,
};



// WEBPACK FOOTER //
// ./src/constants/colors.js